import classes from './LoadingSpinner.module.css'

const LoadingSpinner = () => {
    return (
        <div className={classes.spinnerWrap}>
            <div className={classes.spinner}></div>
        </div>
    )
}

export default LoadingSpinner
